import BaseCollection from "scripts/collections/baseCollection";
import ApiCollectionHoc from "scripts/hoc/apiCollectionHoc";

class BaseApiCollection extends ApiCollectionHoc(BaseCollection) {}

export default BaseApiCollection;
